import TableSimple from "ds/components/TableSimple";
import { Stack } from "types/generated";

import useStacksTableStore from "./useStacksTableStore";
import { STACKS_TABLE_CELLS } from "./Cells";
import useStackListAnalytics from "../useStackListAnalytics";
import { ANALYTICS, FILTERS_ORDER_SETTINGS_KEY, SORT_CONFIG } from "../constants";

type StacksTableProps = {
  stacks: Stack[];
  loading: boolean;
};

const StacksTable = ({ stacks, loading }: StacksTableProps) => {
  return (
    <TableSimple
      data={stacks}
      loading={loading}
      store={useStacksTableStore}
      ariaLabel="Stacks table"
      cellPerColumn={STACKS_TABLE_CELLS}
      trackAnalytics={useStackListAnalytics}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      analyticsPage={ANALYTICS.analyticsPage}
      sortConfig={SORT_CONFIG}
    />
  );
};

export default StacksTable;
